import { LitElement, html, css } from 'lit-element';
import { AppStyles } from '../styles/app-styles';
import '@trumedianetworks/tmn-core-components/src/tmn-loading';

class LoadingLogo extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...AppStyles.styles,
            css`
                :host {
                    position: fixed;
                    top: 40%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    background-color: var(--light-gray-100);
                    border-radius: 16px;
                    padding: 12px;
                    min-width: 160px;
                    flex-flow: column;
                    align-items: center;
                    border: 1px solid var(--app-primary-dark-color);
                }
                .logo {
                    margin-top: 10px;
                    height: 40px;
                }

                /* .loading-container {

                } */
                .loading {
                    padding: 10px;
                    width: 100px;
                    color: var(--app-primary-dark-color);
                }
            `,
        ];
    }
    renderLogo() {
        /// todo review the mapping process here, i don't love assets
        return html`<img
            src="/assets/images/trumedia_networks.svg"
            alt="TruMedia Networks"
            class="logo" />`;
    }

    render() {
        return html`
            ${this.renderLogo()}
            <tmn-loading class="loading" size="40px" fontSize="20px"> </tmn-loading>
        `;
    }
}

customElements.define('loading-logo', LoadingLogo);
